import { Flex, Text, Textarea } from "@mantine/core";

import type { GuideMainInput } from "../logic-builder";

interface GuideCardFreeTextInputProps {
    freeTextInput: GuideMainInput;
    value: string;
    onInput: (val: string) => void;
    validationError?: string;
}

export function GuideCardFreeTextInput({
    freeTextInput,
    validationError,
    value,
    onInput,
}: GuideCardFreeTextInputProps) {
    return (
        <Flex direction="column" w="100%">
            {validationError && (
                <Text size="xs" c="var(--mantine-color-red-text)">
                    {validationError}
                </Text>
            )}
            <Textarea
                aria-label={freeTextInput.placeholder ?? "Free text"}
                autosize
                minRows={2}
                maxRows={6}
                value={value}
                onChange={(e) => onInput(e.currentTarget.value)}
                placeholder={freeTextInput.placeholder}
                w="100%"
                error={!!validationError}
                className={freeTextInput.maskFS === false ? undefined : "fs-mask"}
            />
        </Flex>
    );
}
